import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { H3 } from "../atoms"
import { ref, watchEffect } from "vue"
import { ICompanyInfo } from "../../utils/interfaces"
import { useStore } from "@/store"
import { companies } from "@/utils/companies"


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyModal',
  setup(__props) {

const store = useStore()
const dialog = ref(false)
const companyInfo = ref<ICompanyInfo | null>(null)
const selectedEmpresa = ref(store.state.selectedCompany)

const updateEmpresaInfo = () => {
	if (selectedEmpresa.value) {
		companyInfo.value = {
			company: selectedEmpresa.value,
			informations: companies[selectedEmpresa.value],
		}
	} else {
		companyInfo.value = null
	}
}

watchEffect(() => {
	updateEmpresaInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      "prepend-icon": "$info",
      variant: "elevated",
      style: {"background":"rgb(0, 238, 140)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(H3), null, {
          default: _withCtx(() => [
            _createTextVNode(" Informações do tomador ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
      activator: "parent",
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            (companyInfo.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(H3), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(companyInfo.value.company), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyInfo.value.informations, (info) => {
                        return (_openBlock(), _createElementBlock("li", { key: info }, _toDisplayString(info), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  block: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Fechar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})